import React from "react";

import {
  letterDict,
  chunkArray,
  boundariedChunkedArray
} from "Components/AutoCompleteList";
import { state } from "State";
import { geoAggregations } from "Data";
import { geo_aggregations_lookup } from "Lookups";

import withState from "recompose/withState";
import withProps from "recompose/withProps";

const withSearchInput = withState("searchInput", "setSearchInput", "");

const addUpdateCallback = withProps({
  setGeoAggregationValue: (value, geo_division) =>
    state.select("domain_data").merge({
      geo_aggregation: geo_division,
      geo_aggregation_value: value
    }) &&
    state.select("ui").merge({
      search_open: ""
    })
});

const selectFromState = ({ domain_data, ui }, searchInput) => ({
  collection: (
    geoAggregations[domain_data.year][ui.secondary_search_division] || []
  ).filter(name => name.toLowerCase().indexOf(searchInput.toLowerCase()) !== -1)
});

const SecondarySearchMenu = ({
  hidden,
  tree,
  searchInput,
  setSearchInput,
  setGeoAggregationValue
}) =>
  selectFromState(tree, searchInput).chain(({ collection }) => (
    <div
      style={{ overflowY: "scroll", flex: 1 }}
      hidden={hidden}
      id="secondary-search-menu"
      className="flex-row justify-content-start fade p-3 black"
    >
      <div className="animated fadein col-12">
        <input
          type="text"
          className="mb-4"
          value={searchInput}
          placeholder={`Search ${
            geo_aggregations_lookup[tree.ui.secondary_search_division]
          }...`}
          onChange={e => setSearchInput(e.target.value)}
          onKeyPress={e =>
            e.key == "Enter" &&
            collection.length == 1 &&
            setGeoAggregationValue(
              collection[0],
              tree.ui.secondary_search_division
            ) &&
            setSearchInput("")
          }
        />

        <div className="col-12">
          <div className="row pb-4">
            {letterDict(
              collection,
              value =>
                state.select("ui").merge({ search_open: "" }) &&
                state.select("domain_data").merge({
                  geo_aggregation_value: value,
                  geo_aggregation: tree.ui.secondary_search_division
                }) &&
                setSearchInput(""),
              { color: "white" }
            )
              .chain(col =>
                boundariedChunkedArray(Math.ceil(col.length / 20))(col)
              )
              .map((col, index) => (
                <div key={index} className="col-md-3 col-sm-4">
                  {col}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  ));

export default addUpdateCallback(withSearchInput(SecondarySearchMenu));



// WEBPACK FOOTER //
// ./components/SecondarySearchMenu.js